import { defineComponent, ref } from "vue";
import POSConfigModule from "@/store/modules/pos-config";
import { OpenCashDrawerOptions } from "@/interfaces/cash-drawer";
import { useI18n } from "vue-i18n";
import PrinterConfigModule from "@/store/modules/printers-config";
export default defineComponent({
  name: "CashDrawerSettings",
  components: {},
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var selectedOption = ref(POSConfigModule.openCashDrawer);
    var autoPrintReceipt = ref(PrinterConfigModule.autoPrintReceipt);
    var optionsArray = [{
      label: t("select.after-cash-payment"),
      value: OpenCashDrawerOptions.AFTER_CASH_PAYMENT
    }, {
      label: t("select.after-every-sale"),
      value: OpenCashDrawerOptions.AFTER_EVERY_SALE
    }, {
      label: t("select.never-open"),
      value: OpenCashDrawerOptions.NEVER
    }];

    function toggleAutoPrintReceipt(status) {
      autoPrintReceipt.value = status;
    }

    return {
      selectedOption: selectedOption,
      optionsArray: optionsArray,
      autoPrintReceipt: autoPrintReceipt,
      toggleAutoPrintReceipt: toggleAutoPrintReceipt
    };
  }
});